import { useState, useEffect } from "react";
import { getCrmFirmalar, addCrmFirma, updateCrmFirma, deleteCrmFirma, getCrmSektorler } from "../services/api";

const EMPTY_FORM = { unvan: "", sektor: "", telefon: "", email: "", adres: "", notlar: "" };

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const th   = { padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "var(--text-muted)", borderBottom: "1px solid var(--border-hairline)", textTransform: "uppercase", letterSpacing: ".05em" };
const td   = { padding: "11px 14px", fontSize: 13, color: "var(--text-primary)", borderBottom: "1px solid var(--border-hairline)" };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

export default function CrmFirmalar() {
  const [firmalar, setFirmalar] = useState([]);
  const [sektorler, setSektorler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [msg, setMsg] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editKod, setEditKod] = useState(null);

  useEffect(() => {
    load();
    getCrmSektorler().then((r) => setSektorler(r.data)).catch(() => {});
  }, []);

  async function load() {
    setLoading(true);
    try { setFirmalar((await getCrmFirmalar()).data); }
    catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      if (editKod) {
        await updateCrmFirma(editKod, form);
        flash("Firma guncellendi");
      } else {
        const res = await addCrmFirma(form);
        flash(`Firma eklendi (${res.data.id})`);
      }
      setForm(EMPTY_FORM);
      setEditKod(null);
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  function handleEdit(f) {
    setEditKod(f.CARI_KOD);
    setForm({
      unvan: f.Unvan || "", sektor: f.Sektor || "", telefon: f.Telefon || "",
      email: f.Email || "", adres: f.Adres || "", notlar: f.Notlar || "",
    });
  }

  function handleCancelEdit() {
    setEditKod(null);
    setForm(EMPTY_FORM);
  }

  async function handleDelete(kod, unvan) {
    if (!window.confirm(`"${unvan}" (${kod}) silinsin mi?`)) return;
    try {
      await deleteCrmFirma(kod);
      flash("Silindi");
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Silinemedi", "error");
    }
  }

  const filtered = firmalar.filter((f) =>
    (f.Unvan || "").toLowerCase().includes(search.toLowerCase()) ||
    (f.CARI_KOD || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 4 }}>
          {editKod ? `Firma Duzenle (${editKod})` : "Yeni Firma Ekle"}
        </div>
        <div style={{ fontSize: 11, color: "var(--text-faint)", marginBottom: 16 }}>
          Firmalar Netsis cari kartlarindan (TBLCASABIT) gelir. Buradan eklenenler otomatik "C0001" formatinda bir cari koda kaydedilir.
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>UNVAN</div>
              <input style={inp} maxLength={100} value={form.unvan} required
                onChange={(e) => setForm({ ...form, unvan: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>SEKTOR</div>
              <select style={inp} value={form.sektor} onChange={(e) => setForm({ ...form, sektor: e.target.value })}>
                <option value="">Secilmedi</option>
                {sektorler.map((s) => (
                  <option key={s.ID} value={s.Ad}>{s.Ad}</option>
                ))}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TELEFON</div>
              <input style={inp} maxLength={20} value={form.telefon}
                onChange={(e) => setForm({ ...form, telefon: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>EMAIL</div>
              <input style={inp} type="email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>ADRES</div>
              <input style={inp} maxLength={255} value={form.adres}
                onChange={(e) => setForm({ ...form, adres: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>NOTLAR</div>
              <input style={inp} maxLength={50} value={form.notlar}
                onChange={(e) => setForm({ ...form, notlar: e.target.value })} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button type="submit" style={btn("var(--accent)", "#fff")}>{editKod ? "Guncelle" : "Firma Ekle"}</button>
            {editKod && (
              <button type="button" onClick={handleCancelEdit} style={btn("var(--border)", "var(--text-secondary)")}>Iptal</button>
            )}
          </div>
        </form>
      </div>

      <div style={{ ...card, display: "flex", gap: 10, alignItems: "center" }}>
        <input
          style={{ ...inp, maxWidth: 320 }}
          placeholder="Unvan veya cari koda gore ara..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--bg-sidebar)" }}>
              {["Cari Kod", "Unvan", "Sektor", "Telefon", "Email", "Adres", ""].map((h) => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
            {!loading && filtered.length === 0 && <tr><td colSpan={7} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Kayit bulunamadi.</td></tr>}
            {filtered.map((f) => (
              <tr key={f.CARI_KOD}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-card-alt)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 600 }}>{f.CARI_KOD}</td>
                <td style={td}>{f.Unvan}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{f.Sektor || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{f.Telefon || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{f.Email || "-"}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{f.Adres || "-"}</td>
                <td style={{ ...td, display: "flex", gap: 6 }}>
                  <button onClick={() => handleEdit(f)}
                    style={{ background: "var(--accent-bg)", color: "var(--accent-text)", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    Duzenle
                  </button>
                  {/^C\d+$/i.test(f.CARI_KOD || "") && (
                    <button onClick={() => handleDelete(f.CARI_KOD, f.Unvan)}
                      style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                      Sil
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
